import React from "react";

export function Toolbar({ onAddText, onAddImage, onClear }) {
  return (
    <div style={toolbarContainerStyle}>
      <button style={iconButtonStyle} onClick={onAddText} title="Add Text">
        <span style={iconStyle}>T</span>
      </button>
      
      <button style={iconButtonStyle} onClick={onAddImage} title="Add Image">
        <span style={iconStyle}>⊕</span>
      </button>

      {/* <div style={dividerStyle} />
      <button 
        style={{ ...iconButtonStyle, color: '#ff4d4f' }} 
        onClick={} 
        title="Clear Canvas"
      >
        <span style={iconStyle}>✕</span>
      </button>*/}
    </div> 
  );
}

/* -----------------------------
    Styles
------------------------------ */

const toolbarContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center', 
  padding: '12px 4px',
  gap: '8px',
  background: '#f8f9fa',
  borderRight: '1px solid #ddd',
  height: '100%',
  width: '48px',
  boxSizing: 'border-box'
};

const iconButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '6px',
  border: '1px solid transparent',
  background: 'white',
  cursor: 'pointer',
  boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
  padding: 0,
  transition: 'all 0.2s ease'
};

const iconStyle = {
  fontSize: '18px',
  fontWeight: 'bold',
  lineHeight: 1,
  userSelect: 'none'
};

const dividerStyle = {
  width: '20px',
  height: '1px',
  background: '#ddd',
  margin: '8px 0'
};